<template>
  <div class="map">
    <div id="dituContent"></div>
  </div>
</template>
<script>
  import BMap from 'BMap';
  export default{
    name: '',
    data(){
      return {
        map: null,
        phone:null,
        phoneTel:null
      }
    },
    props: {
      mapMessage: {
        default: Object
      }
    },
    watch: {
      mapMessage: function (value) {
        this.createMap();
        if (this.map){
          this.setMapLocation(value.longitude, value.latitude);
        }
      }
    },
    methods: {
      setMapLocation: function (longitude, latitude) {
        var point = new BMap.Point(longitude, latitude);
        //        设定地图的中心点和坐标并将地图显示在地图容器中
        this.map.centerAndZoom(point, 18);
        if (this.mapMessage.phone){
          this.phone = '电话：' + this.mapMessage.phone;
          this.phoneTel = 'tel:' + this.mapMessage.phone;
        }
        var markerArr = [{
          title: this.mapMessage.address,
          content: this.phone,
          contentTel:this.phoneTel,
          point: this.mapMessage.longitude + '|' + this.mapMessage.latitude,
          isOpen: 1,
          icon: {w: 23, h: 25, l: 46, t: 21, x: 9, lb: 12}
        }];
        for (var i = 0; i < markerArr.length; i++) {
          var json = markerArr[i];
          var p0 = json.point.split('|')[0];
          var p1 = json.point.split('|')[1];
          var points = new BMap.Point(p0, p1);
          var iconImg = new BMap.Icon(
            'http://map.baidu.com/image/us_cursor.gif',
            new BMap.Size(json.icon.w, json.icon.h), {
            imageOffset: new BMap.Size(-json.icon.l, -json.icon.t),
            infoWindowOffset: new BMap.Size(json.icon.lb + 5, 1),
            offset: new BMap.Size(json.icon.x, json.icon.h)
          })
          var marker = new BMap.Marker(points, {icon: iconImg});
          var label = new BMap.Label(json.title, {'offset': new BMap.Size(json.icon.lb - json.icon.x + 10, -20)});
          marker.setLabel(label);
          this.map.addOverlay(marker);
          label.setStyle({
            borderColor: '#b052d0',
            color: '#ea6010',
            cursor: 'pointer'
          });
          (function () {
//              var index = i;
            var _iw = new BMap.InfoWindow(
              '<b class="iw_poi_title" ' +
              'title="' + markerArr[i].title + '">' + markerArr[i].title + '' +
              '</b>' +
              '<br>' +
              '<div class="iw_poi_content" >' + markerArr[i].content + '</div>'
            );
            var _marker = marker;
            _marker.addEventListener('click', function () {
              this.openInfoWindow(_iw);
            });
            _iw.addEventListener('open', function () {
              _marker.getLabel().hide();
            })
            _iw.addEventListener('close', function () {
              _marker.getLabel().show();
            })
            label.addEventListener('click', function () {
              _marker.openInfoWindow(_iw);
            })
            if (json.isOpen) {
              label.hide();
              _marker.openInfoWindow(_iw);
            }
          })()
        }
      },
      createMap: function () {
        //  在百度地图容器中创建一个地图
        let map = new BMap.Map('dituContent');
        this.map = map;
        //  定义一个中心点坐标
        this.setMapLocation(this.mapMessage.longitude, this.mapMessage.latitude);
//            启用地图拖拽事件，默认启用(可不写)
        map.enableDragging();
//          启用地图滚轮放大缩小
        map.enableScrollWheelZoom();
//          启用鼠标双击放大，默认启用(可不写)
        map.enableDoubleClickZoom();
//          启用键盘上下左右键移动地图
        map.enableKeyboard();
//          向地图中添加缩放控件
//          var ctrl_nav = new BMap.NavigationControl({anchor: BMAP_ANCHOR_TOP_LEFT, type:BMAP_NAVIGATION_CONTROL_LARGE});
//          map.addControl(ctrl_nav);
//          向地图中添加缩略图控件
//          var ctrl_ove = new BMap.OverviewMapControl({anchor: BMAP_ANCHOR_BOTTOM_RIGHT, isOpen:1});
//          map.addControl(ctrl_ove);
//          向地图中添加比例尺控件
//          var ctrl_sca = new BMap.ScaleControl({anchor: BMAP_ANCHOR_BOTTOM_LEFT});
//          map.addControl(ctrl_sca);
      }
    },
    mounted: function () {
//      创建和初始化地图
      this.createMap();
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../../../assets/styles/index";
  .map {
    width: 100%;
    height: 800px;
    position: relative;
    #dituContent {
      width: 100%;
      height: 100%;
      border: #ccc solid 1px;
    }
  }

  .iw_poi_title {
    color: #CC5522;
    font-size: 0.3rem;
    font-weight: bold;
    overflow: hidden;
    padding-right: 13px;
    white-space: nowrap
  }

  .iw_poi_content {
    font: 0.26rem arial, sans-serif;
    color:$color-black !important;
    overflow: visible;
    padding-top: 4px;
    white-space: -moz-pre-wrap;
    word-wrap: break-word
  }
</style>
